import { z } from "zod";
import i18next from "../i18n";

// Initialize Zod V4 locale based on current language
export const initializeZodLocale = (): void => {
  const currentLanguage = i18next.language || "en";

  // Map i18next language codes to Zod locale names
  const localeMap: Record<string, keyof typeof z.locales> = {
    ar: "ar",
    cs: "cs",
    de: "de",
    en: "en",
    es: "es",
    fi: "fi",
    fr: "fr",
    he: "he",
    it: "it",
    ja: "ja",
    ko: "ko",
    nl: "nl",
    pl: "pl",
    pt: "pt",
    "pt-BR": "pt",
    ru: "ru",
    sv: "sv",
    tr: "tr",
    // Add more mappings as needed
  };

  const zodLocale = localeMap[currentLanguage] || "en";

  try {
    // Use Zod V4 built-in locales
    z.config(z.locales[zodLocale]());
  } catch (error) {
    console.warn(
      `Failed to load Zod locale for ${currentLanguage}, falling back to English:`,
      error,
    );
    // Fallback to English locale
    z.config(z.locales.en());
  }
};
